export const LANDING = "/";
export const CONTACT_US = "/contact";